module.exports = __webpack_public_path__ + "static/img/5.c8bb858.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/result/5.png
// module id = rFB/
// module chunks = 57